// extracted by mini-css-extract-plugin
export default {"ModalCall":"modal-call_ModalCall__HvR2+"};